import axios from '../axios';
import env from "react-dotenv";

// API for get user courses
export const GetUserCourses = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/course`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// API for get user cap courses
export const GetUserCapCourses = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`user/cap-course`)
      .then((res) => {
        if (res.status === 200) {
          let result = res?.data;
          resolve(result);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchAppLinksData = async () => {
  try {
    let res = await fetch(`${env.BUCKET_URL}static/app-links.json`, {
      method: 'GET',
    })

    res = await res.json();

    if (res.status === 200) {
      let result = res?.appLinks;
      return result;
    } else {
      let res = await updateAppLinksData();
      if (res?.status === 200) {
        let result = res?.data.appLinks;
        return result;
      }
    }
  } catch (error) {
    console.error(error.message);
    let res = await updateAppLinksData();
    if (res?.status === 200) {
      let result = res?.data.appLinks;
      return result;
    }
  }
};

export const updateAppLinksData = () => {
  return new Promise((resolve, reject) => {
    axios
      .post(`master-data/get-courses`)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        } else {
          reject(res?.data?.message);
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        reject(error);
      });
  });
};
